const cssStyles = (pageType, seoUnauthExperiments) => {
  const inPinGridOptGroup =
    seoUnauthExperiments &&
    ((pageType === 'pin' &&
      (
        seoUnauthExperiments.v2GetGroup('pin_grid_style_format_optimization_pin_v3') || ''
      ).startsWith('enabled')) ||
      (pageType === 'board' &&
        (
          seoUnauthExperiments.v2GetGroup('pin_grid_style_format_optimization_board_v3') || ''
        ).startsWith('enabled')));

  return inPinGridOptGroup
    ? `
.GrowthUnauthPinImage:hover, .GrowthUnauthPinImage:hover .GrowthUnauthPinImage__imageDim,
.GrowthUnauthPinImage:hover .PinSaveButton__hoverState, .GrowthUnauthPinImage:hover .GrowthUnauthPinImage__like,
.GrowthUnauthPinImage:hover .GrowthUnauthPinImage__contentLink {
  opacity: 1;
}

.GrowthUnauthPinImage__Image {
  -webkit-transition: opacity 0.04s linear;
  transition: opacity 0.04s linear;
  border-radius: inherit;
  opacity: 1;
  display: block;
  margin: 0 auto;
  border: 0;
  width: 100%;
  max-width: 100%;
  vertical-align: middle;
  position: relative;
}

 .GrowthUnauthPinImage__imageDim {
   cursor: pointer;
   bottom: 0;
   left: 0;
   right: 0;
   top: 0;
   position: absolute;
   pointer-events: none;
 }


.GrowthUnauthPinImage {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border-radius: 6px;
  display: block;
  padding: 0;
  font-weight: bold;
  text-decoration: none;
  color: #717171;
  overflow: hidden;
}

.GrowthUnauthPinImage__placeholder {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  text-overflow: ellipsis;
  bottom: 0;
  color: #f7f7f7;
  font-size: 12px;
  height: 56px;
  left: 0;
  line-height: 150%;
  margin-top: -6px;
  opacity: 0.5;
  padding: 0 14px;
  position: absolute;
  right: 0;
  text-align: center;
  text-shadow: 0 -1px rgba(0,0,0,0.17);
  top: 45%;
  word-wrap: break-word;
}

.GrowthUnauthPinImage__imageDim, .PinSaveButton__hoverState, .GrowthUnauthPinImage__like,
.GrowthUnauthPinImage__contentLink {
  opacity: 0;
}
.GrowthUnauthPinImage__expandButton {
  background: rgba(255,255,255,0.85);
}
.GrowthUnauthPinImage__expandButton:hover {
  background: rgba(255,255,255,0.95);
}
.GrowthUnauthPinImage__expandButton:after {
  background: rgba(0,0,0,0.1);
  bottom: 0;
  content: '';
  height: 1px;
  left: 0;
  position: absolute;
  width: 100%;
}
.GrowthUnauthPinImage__dimGradient {
  background-color: rgba(0,0,0,0.15);
  background: -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0,0,0,0.3)));
  background: -webkit-linear-gradient(transparent, rgba(0,0,0,0.3));
  background: linear-gradient(transparent, rgba(0,0,0,0.3));
}
.GrowthUnauthPinImage__dimGradientDark {
  background-color: rgba(0,0,0,0.60);
  background: -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0,0,0,0.3)));
  background: -webkit-linear-gradient(transparent, rgba(0,0,0,0.3));
  background: linear-gradient(transparent, rgba(0,0,0,0.3));
  bottom: 0;
  height: 100px;
  left: 0;
  position: absolute;
  right: 0;
}

.GrowthUnauthPinImage__dimOverlayDark {
  opacity: 0.55;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background-color: #000;
  border-radius: 6px 6px 0 0;
  position: absolute;
  -webkit-transition: opacity .04s linear;
  transition: opacity .04s linear;
}

.GrowthUnauthPin_brioPin_toggled::before {
  background: white;
  border-radius: 8px;
  content: " " !important;
  height: 100%;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  -webkit-transform: scale(0.96);
  -ms-transform: scale(0.96);
  transform: scale(0.96);
  width: 100%;
}
.GrowthUnauthPin_brioPin_toggled {
  margin: -5px;
  padding: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}

.GrowthUnauthPin_brioPin::before {
  background: rgba(0,0,0,0.05);
  border-radius: 8px;
  content: " " !important;
  height: 100%;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  -webkit-transform: scale(0.96);
  -ms-transform: scale(0.96);
  transform: scale(0.96);
  width: 100%;
}
.GrowthUnauthPin_brioPin {
  cursor: -webkit-pointer;
  cursor: pointer;
  margin: -5px;
  padding: 5px;
}
.GrowthUnauthPin_brioPin:hover::before {
  -webkit-animation: tapAnimation 0.25s cubic-bezier(0.31, 1, 0.34, 1) forwards;
  animation: tapAnimation 0.25s cubic-bezier(0.31, 1, 0.34, 1) forwards;
}
@keyframes tapAnimation {
    0% {
        opacity: 0;
        transform: scale(.96);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}
`
    : `.GrowthUnauthPinImage:hover, .GrowthUnauthPinImage:hover .GrowthUnauthPinImage__imageDim,
.GrowthUnauthPinImage:hover .PinSaveButton__hoverState, .GrowthUnauthPinImage:hover .GrowthUnauthPinImage__like,
.GrowthUnauthPinImage:hover .GrowthUnauthPinImage__contentLink {
  opacity: 1;
}

.GrowthUnauthPinImage__imageDim, .PinSaveButton__hoverState, .GrowthUnauthPinImage__like,
.GrowthUnauthPinImage__contentLink {
  opacity: 0;
}
.GrowthUnauthPinImage__expandButton {
  background: rgba(255,255,255,0.85);
}
.GrowthUnauthPinImage__expandButton:hover {
  background: rgba(255,255,255,0.95);
}
.GrowthUnauthPinImage__expandButton:after {
  background: rgba(0,0,0,0.1);
  bottom: 0;
  content: '';
  height: 1px;
  left: 0;
  position: absolute;
  width: 100%;
}
.GrowthUnauthPinImage__dimGradient {
  background-color: rgba(0,0,0,0.15);
  background: -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0,0,0,0.3)));
  background: -webkit-linear-gradient(transparent, rgba(0,0,0,0.3));
  background: linear-gradient(transparent, rgba(0,0,0,0.3));
}
.GrowthUnauthPinImage__dimGradientDark {
  background-color: rgba(0,0,0,0.60);
  background: -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0,0,0,0.3)));
  background: -webkit-linear-gradient(transparent, rgba(0,0,0,0.3));
  background: linear-gradient(transparent, rgba(0,0,0,0.3));
}

.GrowthUnauthPin_brioPin_toggled::before {
  background: white;
  border-radius: 8px;
  content: " " !important;
  height: 100%;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  -webkit-transform: scale(0.96);
  -ms-transform: scale(0.96);
  transform: scale(0.96);
  width: 100%;
}
.GrowthUnauthPin_brioPin_toggled {
  margin: -5px;
  padding: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}

.GrowthUnauthPin_brioPin::before {
  background: rgba(0,0,0,0.05);
  border-radius: 8px;
  content: " " !important;
  height: 100%;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  -webkit-transform: scale(0.96);
  -ms-transform: scale(0.96);
  transform: scale(0.96);
  width: 100%;
}
.GrowthUnauthPin_brioPin {
  cursor: -webkit-pointer;
  cursor: pointer;
  margin: -5px;
  padding: 5px;
}
.GrowthUnauthPin_brioPin:hover::before {
  -webkit-animation: tapAnimation 0.25s cubic-bezier(0.31, 1, 0.34, 1) forwards;
  animation: tapAnimation 0.25s cubic-bezier(0.31, 1, 0.34, 1) forwards;
}
@keyframes tapAnimation {
    0% {
        opacity: 0;
        transform: scale(.96);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}`;
};

export default cssStyles;
